import { Injectable } from '@angular/core';
import { StorageService } from '../storage.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiManagerService {
  constructor(protected storageService: StorageService) {}

  protected get admin() {
    return this.storageService.returnJSONIfValid('CURRENT_USER');
  }

  protected get mowaAdmin() {
    return this.admin.role === 'mowa_admin' ? true : false;
  }

  protected get mowaAdminCountryIso() {
    return this.admin['company.country'];
  }

  protected get defaultApiUrl() {
    return environment.apiUrlCH;
  }

  protected get cmsApiUrl() {
    return environment.cmsApiUrl;
  }

  protected get apiCH() {
    return environment.apiUrlCH;
  }

  protected get apiEU() {
    return environment.apiUrlDE;
  }

  protected get adminBaseApiUrl() {
    return `${this.admin['company.baseAPIURL']}`;
  }

  protected get mowaAdminApiUrl() {
    const server = this.storageService.getJSON('SERVER');
    if (server === null || server === 'CH') {
      return this.getApiCH();
    } else {
      return this.getApiEU();
    }
  }

  getApi(): string {
    if (!this.admin) {
      return this.defaultApiUrl;
    } else if (this.mowaAdmin) {
      return this.mowaAdminApiUrl;
    } else {
      return this.adminBaseApiUrl;
    }
  }

  apiBuilder(endpoint: string): string {
    return `${this.getApi() + '/v1' + endpoint}`;
  }

  getApiCH(): string {
    return this.apiCH;
  }

  getApiEU(): string {
    return this.apiEU;
  }

  getAllApi() {
    return [
      {
        server: 'EU',
        api: this.getApiEU(),
      },
      {
        server: 'CH',
        api: this.getApiCH(),
      },
    ];
  }

  getCMSApiUrl(): string {
    return this.cmsApiUrl;
  }
}
